import React, { useState } from "react";
import "./CounsellingForm.css";
import { db } from "./firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const CounsellingForm = ({ onClose, onSuccess }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    profession: "",
    college: "",
    organization: "",
    availableDay: "",
    additionalInfo: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      name: form.name,
      email: form.email,
      phone: form.phone,
      profession: form.profession,
      college: form.college || "",
      organization: form.organization || "",
      availableDay: form.availableDay,
      additionalInfo: form.additionalInfo,
      timestamp: serverTimestamp(),
    };

    try {
      await addDoc(collection(db, "counselling_forms"), formData);
      alert("Your counselling request has been submitted!");
      onSuccess(); // You may close modal or reset
    } catch (err) {
      console.error("Error saving counselling form:", err);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="counselling-form-overlay">
      <div className="counselling-form">
        <h2>Book Your Free Counselling Session</h2>
        <form onSubmit={handleSubmit}>
          <input name="name" type="text" placeholder="Full Name" value={form.name} onChange={handleChange} required />
          <input name="email" type="email" placeholder="Email" value={form.email} onChange={handleChange} required />
          <input name="phone" type="tel" placeholder="Phone Number" value={form.phone} onChange={handleChange} required />

          <select name="profession" value={form.profession} onChange={handleChange} required>
            <option value="">Select Profession</option>
            <option value="student">Student</option>
            <option value="employed">Employed</option>
            <option value="other">Other</option>
          </select>

          {form.profession === "student" && (
            <input name="college" type="text" placeholder="School/College Name" value={form.college} onChange={handleChange} required />
          )}

          {form.profession === "employed" && (
            <input name="organization" type="text" placeholder="Organization Name" value={form.organization} onChange={handleChange} required />
          )}

          <input
            name="availableDay"
            type="text"
            placeholder="Preferred Day(s) for Session"
            value={form.availableDay}
            onChange={handleChange}
            required
          />

          <textarea
            name="additionalInfo"
            placeholder="Any specific topic or concern you want to discuss (optional)"
            rows="3"
            value={form.additionalInfo}
            onChange={handleChange}
          />

          <div className="form-actions">
            <button type="submit">Submit</button>
            <button type="button" onClick={onClose} className="cancel-btn">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CounsellingForm;
